/* eslint-disable no-continue */
export type ValidationResult = {
  pass: boolean;
  reason: string;
  index?: number;
}

// eachFollows returns { pass: true, reason: "" } if every successive pair in
// the collection passes the given predicate, { pass: false, reason: string }
// otherwise.
export default function eachFollows<T> (
  coll: T[],
  fn: (prev: T, next: T, index?: number) => boolean | ValidationResult,
): ValidationResult {
  for (let i = 0; i < coll.length; i += 1) {
    if (i === 0) {
      continue;
    }

    const result = fn(coll[i - 1], coll[i], i);
    if (typeof result === "boolean") {
      if (result === false) {
        return { pass: false, reason: "", index: i };
      }

      continue;
    } else if (result.pass === false) {
      return { ...result, index: i } as ValidationResult;
    }
  }

  return { pass: true, reason: "" };
}
